import Vue from 'vue'
import VueRouter from 'vue-router'

// 解决导航栏或者底部导航tabBar中的vue-router在3.0版本以上频繁点击菜单报错的问题。
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(VueRouter)

const routers = [
  {
    path: "/redirect",
    component: () => import("@/pages/de"),
    hidden: true,
    children: [
      {
        path: "/redirect/:path(.*)",
        component: () => import("@/pages/redirect"),
      },
    ],
  }, {
    path: '/',
    name: "Login",
    meta: {
      title: '欢迎登录'
    },
    component: () => import('@/pages/login')
  }, {
    path: '/IndexHeader',
    component: () => import('@/pages/index/indexHeader')
  }, {
    path: '/IndexMenu',
    component: () => import('@/pages/index/indexMenu')
  },
  {
    path: "/DownloadApp",
    name: "Downloadapp",
    meta: {
      title: "下载App",
    },
    component: () => import("@/pages/downloadapp"),
  },
  {
    path: "/ChangePassword",
    name: "changePassword",
    meta: {
      title: "修改密码",
    },
    component: () => import("@/pages/my/changePassword"),
  }, {
    path: "/Index",
    name: "Index",
    meta: {
      title: "智数云ERP",
    },
    component: () => import("@/pages/index/index"),
    children: [
      {
        path: "/Home",
        name: "Home",
        meta: {
          title: "智数云ERP",
          affix: true
        },
        component: () => import("@/pages/home"),
      },
      {
        path: "/My",
        name: "My",
        meta: {
          title: "我的",
          notPage: true
        },
        component: () => import("@/pages/de"),
        children: [
          {
            path: "/MyInfo",
            name: "MyInfo",
            meta: {
              title: "我的信息",
            },
            component: () => import("@/pages/my/myInfo"),
          },
          //todo 增加登录历史功能
          // {
          //   path: "/MyLoginHistory",
          //   name: "MyLoginHistory",
          //   meta: {
          //     title: "我的登录历史",
          //   },
          //   component: () => import("@/pages/my/loginHistory"),
          // },
        ]
      },
    ],
  }
]


const router = new VueRouter({
  mode: 'hash',
  routes: routers
})

let oneRun = true;
router.beforeEach(async (to, from, next) => {
  let storageOriginRouters = Vue.prototype.$storageUtil.getOriginRouters();
  if (oneRun && !Vue.prototype.$store.routers) {
    oneRun = false;
    let index = router.options.routes.findIndex((d) => {
      return d.path == "/Index";
    });
    let rrr = router.options.routes;
    let handleRouterRes = await Vue.prototype.$jsTool.handleRouters(storageOriginRouters);
    rrr.splice(index, 1, {
      ...router.options.routes[index],
      children: [
        router.options.routes[index].children[0],
        router.options.routes[index].children[1],
      ].concat(...handleRouterRes),
    });
    rrr.push({
      path: "/404",
      name: "404",
      meta: {
        title: "页面找不到了",
      },
      component: () => import("@/pages/404"),
    }, {
      path: '*',
      redirect: {
        name: "404"
      }
    })
    router.options.routes = rrr;
    //动态添加路由
    rrr.forEach((res) => {
      router.addRoute(res);
    });
    Vue.prototype.$store.commit("setRouters", rrr);
    // next({ ...to })的目的,是保证路由添加完了再进入页面 (可以理解为重进一次)
    // 重进一次, 不保留重复历史
    next({
      ...to,
      replace: true
    })
  } else {
    // if (to.meta.title) {
    //   document.title = to.meta.title
    // }
    next();
  }
})


export default router;


// WEBPACK FOOTER //
// ./src/router/index.js